module.exports = {
      id: "icon-card-visa-usage",
      viewBox: "0 0 44 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-card-visa",
      toString: function () {
        return this.url;
      }
    }